import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable, Injector} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {AppLanguageService} from './app-language.service';
import {normalizeBaseUrl} from '../api/api-url';

function shouldAddLanguageHeader(requestUrl: string): boolean {
  const baseUrl = normalizeBaseUrl(environment.apiBaseUrl ?? '');
  if (!baseUrl) {
    return false;
  }

  return requestUrl.startsWith(baseUrl);
}

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  constructor(private readonly injector: Injector) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!shouldAddLanguageHeader(request.url)) {
      return next.handle(request);
    }

    const appLanguageService = this.injector.get(AppLanguageService);

    return next.handle(request.clone({
      setHeaders: {
        'Accept-Language': request.headers.get('Accept-Language') ?? appLanguageService.languageCode,
      },
    }));
  }
}
